import _extends from "@babel/runtime/helpers/esm/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/esm/objectWithoutProperties";
var _excluded = ["children", "title", "user", "logout", "login", "primary", "secondary", "appsMenuProps", "userMenuProps", "sx", "titleChipProps"];
import React, { Fragment, memo, useMemo } from 'react';
import AppBar from "@mui/material/AppBar/AppBar.js";
import Box from "@mui/material/Box/Box.js";
import Grid from "@mui/material/Grid/Grid.js";
import Toolbar from "@mui/material/Toolbar/Toolbar.js";
import AppsMenu from "./AppsMenu.js";
import ProductTitle from "./ProductTitle.js";
import TitleChip from "./TitleChip.js";
import UserMenu from "./UserMenu.js";

/**
 * Navigation bar for use as header in Planet apps
 */
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export var NavBar = function NavBar(_ref) {
  var children = _ref.children,
    title = _ref.title,
    user = _ref.user,
    logout = _ref.logout,
    login = _ref.login,
    primary = _ref.primary,
    secondary = _ref.secondary,
    appsMenuProps = _ref.appsMenuProps,
    userMenuProps = _ref.userMenuProps,
    sx = _ref.sx,
    titleChipProps = _ref.titleChipProps,
    props = _objectWithoutProperties(_ref, _excluded);
  var showSentinelHubApps = useMemo(function () {
    return Boolean(user == null ? void 0 : user.sh_user_id);
  }, [user]);
  return /*#__PURE__*/_jsx(AppBar, _extends({
    sx: _extends({
      zIndex: function zIndex(theme) {
        return theme.zIndex.drawer + 1;
      }
    }, sx)
  }, props, {
    children: /*#__PURE__*/_jsx(Toolbar, {
      variant: "dense",
      component: Grid,
      container: true,
      disableGutters: true,
      sx: {
        py: 0,
        px: 1
      },
      children: children ? children : /*#__PURE__*/_jsxs(Fragment, {
        children: [/*#__PURE__*/_jsxs(Grid, {
          direction: "row",
          container: true,
          item: true,
          xs: 8,
          alignItems: "center",
          children: [/*#__PURE__*/_jsx(Grid, {
            item: true,
            xs: 6,
            children: primary
          }), /*#__PURE__*/_jsxs(Grid, {
            item: true,
            xs: 6,
            sx: {
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center'
            },
            children: [/*#__PURE__*/_jsx(ProductTitle, {
              title: title,
              divider: !!title
            }), titleChipProps && /*#__PURE__*/_jsx(TitleChip, _extends({}, titleChipProps))]
          })]
        }), /*#__PURE__*/_jsx(Grid, {
          item: true,
          xs: 4,
          children: /*#__PURE__*/_jsxs(Box, {
            display: "flex",
            alignItems: "center",
            justifyContent: "flex-end",
            flexWrap: "nowrap",
            children: [secondary, /*#__PURE__*/_jsx(AppsMenu, _extends({}, appsMenuProps, {
              includeSentinelHubApps: showSentinelHubApps
            })), (user || login || logout) && /*#__PURE__*/_jsx(UserMenu, _extends({
              user: user,
              logout: logout,
              login: login
            }, userMenuProps))]
          })
        })]
      })
    })
  }));
};
export default /*#__PURE__*/memo(NavBar);